<template>
    <v-col cols="3">
        <v-card
                class="mx-auto"
                color="#26c6da"
                dark
                max-width="400">
            <v-card-title>
                <v-icon
                        large
                        left>
                    mdi-chart-line
                </v-icon>
                <span class="title font-weight-light">{{title}}</span>
            </v-card-title>
            <v-card-text class="headline font-weight-bold">

                SubTotal: {{data[0].subtotal}} €<br>
                IRPF: {{data[0].irpf}} €<br>
                IVA: {{data[0].iva}} €<br>
                Total: {{data[0].total}} €
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    export default {
        name: "trimestralCard",
        props: ['title', 'data']
    }
</script>

<style scoped>

</style>